import { Scene } from '../Scene';
import { SceneManifest } from '../SceneManifest';
import { ImageTexture } from '../../texture';
import { SceneLoadProgressTracker } from '../SceneLoadProgress';

export async function loadTextures(
  scene: Scene,
  manifest: SceneManifest,
  tracker?: SceneLoadProgressTracker,
): Promise<void> {
  const entries = Object.entries(manifest.assets.textures);
  let completed = 0;
  await Promise.all(
    entries.map(async ([key, texDef]) => {
      const texture = new ImageTexture({ source: texDef.path });
      await texture.load(scene.ctx);
      texture.translucent = texDef.translucent ?? false;
      scene.textureCache.addTexture(key, texture);
      completed++;
      tracker?.updateStageProgress(completed / Math.max(1, entries.length), key);
    }),
  );
}
